<template>
  <div id="connections">
    <div class="main">
      <div class="search_expand_area">
        <el-button type="text" @click="toggleSearchForm">
          {{$t('cmsg.search')}}
          <i class="el-icon-arrow-right el-icon--right"></i>
        </el-button>
      </div>
      <el-form
        :inline="true"
        :model="searchForm"
        size="mini"
        class="search_form"
        status-icon
        :validate-on-rule-change="false"
        :show-message="false"
      >
        <el-form-item :label="$t('cmsg.lab')">
          <el-input v-model="searchForm.labName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('cmsg.user')">
          <el-input v-model="searchForm.userName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('cmsg.status')">
          <el-select v-model="searchForm.status" filterable>
            <el-option :label="$t('cmsg.all')" value></el-option>
            <el-option v-for="(l,v) in status" :key="v" :label="$t(l)" :value="v"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="default"
            @click="searchSubmit"
            :disabled="tableLoading"
            :loading="tableLoading"
            icon="el-icon-3d-search"
          >{{$t('cmsg.search')}}</el-button>
          <el-button
            type="default"
            @click="onSearchReset"
            icon="el-icon-3d-reset"
          >{{$t('cmsg.reset')}}</el-button>
          <el-button
            type="default"
            @click="dentalConnectionForm.visible=true"
            icon="el-icon-3d-new"
          >{{$t('cmsg.new')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="items" stripe style="width: 100%">
        <el-table-column :label="$t('cmsg.user')">
          <template
            slot-scope="scope"
          >{{scope.row.User.NickName}} {{scope.row.User.Email}} {{scope.row.User.Phone}}</template>
        </el-table-column>
        <el-table-column :label="$t('cmsg.type')" prop="TargetType"></el-table-column>
        <el-table-column :label="$t('cmsg.target')">
          <template slot-scope="scope">
            <span v-if="scope.row.TargetLab !== {}">{{scope.row.TargetLab.Name}}</span>
            <span
              v-if="scope.row.TargetUser !== {}"
            >{{scope.row.TargetUser.NickName}} {{scope.row.TargetUser.Email}} {{scope.row.TargetUser.Phone}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('cmsg.status')">
          <template slot-scope="scope">{{$t(switchStatus(scope.row.Status))}}</template>
        </el-table-column>
        <el-table-column :label="$t('cmsg.action')">
          <template slot-scope="scope">
            <el-button
              type="default"
              class="case_btn"
              size="mini"
              @click="actionConnection(scope.row,'accept')"
              v-if="['init','refused'].indexOf(scope.row.Status) > -1 && (scope.row.TargetUser.UserID === $gf.userId() || scope.row.TLAs.indexOf($gf.userId())>-1)"
            >{{$t('cmsg.accept')}}</el-button>
            <el-button
              type="default"
              class="case_btn"
              size="mini"
              @click="actionConnection(scope.row, 'refuse')"
              v-if="['init','active'].indexOf(scope.row.Status) > -1 && (scope.row.TargetUser.UserID === $gf.userId() || scope.row.TLAs.indexOf($gf.userId())>-1)"
            >{{$t('cmsg.refuse')}}</el-button>
            <el-button
              type="default"
              class="case_btn"
              size="mini"
              @click="actionConnection(scope.row, 'delete')"
              v-if="scope.row.TargetUser.UserID === $gf.userId() || scope.row.TLAs.indexOf($gf.userId())>-1 || scope.row.User.UserID === $gf.userId() || perms.indexOf('dental.admin_dental_connection')>-1"
            >{{$t('cmsg.delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[5, 10, 50, 100, 200, 300, 400]"
        :page-size="pageInfo.pageSize"
        :page-count="pageInfo.pages"
        layout="prev, pager, next, total, sizes"
        :total="pageInfo.total"
      ></el-pagination>
      <el-dialog
        :title="$t('cmsg.newConnection')"
        :visible.sync="dentalConnectionForm.visible"
        @close="resetDentalConnectionForm"
        @open="setDentalConnectionForm"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <p v-html="dentalConnectionForm.description"></p>
        <el-form
          :model="dentalConnectionForm.fields"
          label-width="100px;"
          ref="dentalConnectionForm"
          status-icon
          :validate-on-rule-change="false"
          :show-message="false"
        >
          <el-form-item
            :label="$t('cmsg.user')"
            required
            prop="userID"
            :error="dentalConnectionForm.errors.UserID"
          >
            <el-select
              v-model="dentalConnectionForm.fields.userID"
              filterable
              remote
              :remote-method="remoteMembers"
            >
              <el-option :label="$t('cmsg.all')" value></el-option>
              <el-option v-for="im in members" :key="im.Value" :label="im.Label" :value="im.Value"></el-option>
            </el-select>
          </el-form-item>
          <!-- <hr> -->
          <!-- <el-row> -->
          <!-- <el-col :span="12"> -->
          <el-form-item
            :label="$t('cmsg.lab')"
            prop="targetLabID"
            required
            :error="dentalConnectionForm.errors.TargetLabID"
          >
            <el-select
              v-model="dentalConnectionForm.fields.targetLabID"
              filterable
              remote
              :remote-method="remoteLabs"
            >
              <el-option :label="$t('cmsg.all')" value></el-option>
              <el-option
                v-for="im in labs"
                :key="im.KeyName"
                :label="im.KeyValue"
                :value="im.KeyName"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- </el-col> -->
          <!-- <el-col :span="12"> -->
          <!-- <el-form-item :label="$t('cmsg.orUser')" prop="targetUserID"> -->
          <!-- <el-select
                v-model="dentalConnectionForm.fields.targetUserID"
                filterable
                remote
                :remote-method="remoteUsers"
              >
                <el-option :label="$t('cmsg.all')" value></el-option>
                <el-option
                  v-for="im in users"
                  :key="im.Value"
                  :label="im.Label"
                  :value="im.Value"
                ></el-option>
          </el-select>-->
          <!-- </el-form-item> -->
          <!-- </el-col> -->
          <!-- </el-row> -->
        </el-form>
        <!-- <p v-if="dentalConnectionForm.err">{{dentalConnectionForm.err}}</p> -->
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetDentalConnectionForm">{{$t('cmsg.close')}}</el-button>
          <el-button type="primary" @click="submitDentalConnectionForm">{{$t('cmsg.submit')}}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      status: {
        init: "cmsg.waitAccept",
        refused: "cmsg.refused",
        active: "cmsg.active"
      },
      btnType: {
        delete: "cmsg.delete",
        accept: "cmsg.accept",
        refuse: "cmsg.refuse"
      },
      perms: [],
      searchForm: {
        labName: "",
        userName: "",
        status: ""
      },
      factories: [],
      labs: [],
      devices: [],
      members: [],
      users: [],
      dentalConnectionForm: {
        visible: false,
        loading: false,
        description: "",
        err: "",
        fs: {
          userID: "",
          targetType: "",
          targetID: ""
        },
        fields: {
          userID: "",
          targetLabID: "",
          targetUserID: ""
        },
        errors: {
          UserID: "",
          TargetLabID: "",
          TargetUserID: ""
        }
      }
    };
  },
  methods: {
    switchStatus(v) {
      return this.status[v];
    },
    dialogT(vv, row) {
      Object.keys(row).map((k, i) => {
        if (["User"].indexOf(k) < 0) {
          vv[k] = row[k];
        } else if (k === "User") {
          vv["User"] = row.User.NickName;
        }
      });
      return vv;
    },
    actionConnection(row, tType) {
      console.log(row);
      var t = this;
      var vv = {};
      vv.action = this.$t(this.btnType[tType]);
      vv = this.dialogT(vv, row);
      this.$confirm(
        t.$t("cmsg.connectionActionDialogCT", vv),
        `${t.$t(this.btnType[tType]) + t.$t("cmsg.connections")}`,
        {
          type: "warning",
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.$axios
            .get(`/api/u/dental/connection/action/${row.ID}/${tType}`, {
              json: true,
              validateStatus: function(status) {
                return status >= 200 && status < 404; // default
              }
            })
            .then(res => {
              if (
                res.status === 200 &&
                res.data &&
                res.data.status === "success"
              ) {
                this.$message({
                  type: "success",
                  message: this.$t("cmsg.successAction")
                });
                var t = this;
                setTimeout(function() {
                  window.location = t.$router.resolve({
                    name: "connections",
                    query: t.$route.query
                  }).href;
                }, 3000);
              } else if (
                res.status === 200 &&
                res.data &&
                res.data.status !== "success"
              ) {
                this.$message({
                  type: "error",
                  message: `${this.$t("cmsg.mting")}: ${res.data.result}.`
                });
              } else {
                console.log(res);
                this.$message({
                  type: "warning",
                  message: this.$t("cmsg.mting")
                });
              }
            })
            .catch(e => {
              console.log(e);
              this.$message({
                type: "warning",
                message: this.$t("cmsg.mting")
              });
            });
        })
        .catch(e => {
          console.log(e);
        });
    },
    submitDentalConnectionForm() {
      console.log(this.dentalConnectionForm.fields);
      //   return false;
      this.dentalConnectionForm.fs.userID = this.dentalConnectionForm.fields.userID;
      if (this.dentalConnectionForm.fields.targetLabID !== "") {
        this.dentalConnectionForm.fs.targetType = "lab";
        this.dentalConnectionForm.fs.targetID = this.dentalConnectionForm.fields.targetLabID;
      }
      if (this.dentalConnectionForm.fields.targetUserID !== "") {
        this.dentalConnectionForm.fs.targetType = "user";
        this.dentalConnectionForm.fs.targetID = this.dentalConnectionForm.fields.targetUserID;
      }
      this.dentalConnectionForm.err = "";
      this.$refs["dentalConnectionForm"].validate(valid => {
        if (valid) {
          this.dentalConnectionForm.loading = true;
          this.$axios
            .post(
              `/api/u/dental/connection/add`,
              this.dentalConnectionForm.fs,
              {
                json: true,
                validateStatus: function(status) {
                  return status >= 200 && status < 404; // default
                }
              }
            )
            .then(res => {
              console.log(res);
              this.dentalConnectionForm.loading = false;
              if (
                res.status === 200 &&
                res.data &&
                res.data.status === "success"
              ) {
                this.$message({
                  type: "success",
                  message: this.$t("cmsg.successAction")
                });
                this.dentalConnectionForm.visible = false;
                var t = this;
                setTimeout(function() {
                  t.resetDentalConnectionForm();
                  window.location = t.$router.resolve({
                    name: "connections",
                    query: t.$route.query
                  }).href;
                }, 3000);
              } else if (
                res.status === 200 &&
                res.data &&
                res.data.status !== "success"
              ) {
                var ermsg = {};
                try {
                ermsg = JSON.parse(res.data.result);
                }catch(e){
                  console.log(e);
                }
                Object.keys(ermsg).map((erk, i) => {
                  this.dentalConnectionForm.errors[erk] = this.$t(
                    "cmsg.errField"
                  );
                });
                this.dentalConnectionForm.err = res.data.result;
              } else if (
                res.status === 400 &&
                res.data &&
                res.data.status !== "success"
              ) {
                var ermsg = {};
                try {
                ermsg = JSON.parse(res.data.result);
                }catch(e){
                  console.log(e);
                }
                Object.keys(ermsg).map((erk, i) => {
                  this.dentalConnectionForm.errors[erk] = this.$t(
                    "cmsg.errField"
                  );
                });
                this.dentalConnectionForm.err = res.data.result;
              } else {
                console.log(res);
                this.$message({
                  type: "warning",
                  message: this.$t("cmsg.mting")
                });
              }
            })
            .catch(e => {
              console.log(e);
              this.dentalConnectionForm.loading = false;
              this.$message({
                type: "warning",
                message: this.$t("cmsg.mting")
              });
            });
        } else {
          this.dentalConnectionForm.loading = false;
          return false;
        }
      });
    },
    resetDentalConnectionForm() {
      this.dentalConnectionForm = {
        visible: false,
        loading: false,
        description: "",
        err: "",
        fs: {
          userID: "",
          targetType: "",
          targetID: ""
        },
        fields: {
          userID: "",
          targetLabID: "",
          targetUserID: ""
        },
        errors: {
          UserID: "",
          TargetLabID: "",
          TargetUserID: ""
        }
      };
    },
    async setDentalConnectionForm() {
      await this.$axios
        .get(`/api/u/dental/member/options`, {
          validateStatus: function(status) {
            return status >= 200 && status < 404; // default
          }
        })
        .then(res => {
          console.log(res);
          if (
            res.status === 200 &&
            res.data &&
            res.data.result &&
            res.data.result !== null &&
            Array.isArray(res.data.result)
          ) {
            this.members = res.data.result;
            this.members.forEach(member => {
              if (member.Value === this.$userId) {
                console.log(member);
                this.dentalConnectionForm.fields.userID = this.$userId;
              }
            });
          }
        });
      await this.$axios
        .get(`/api/u/dental/factory/options?factoryType=lab`, {
          validateStatus: function(status) {
            return status >= 200 && status < 404; // default
          }
        })
        .then(res => {
          console.log(res);
          if (
            res.status === 200 &&
            res.data &&
            res.data.result &&
            res.data.result !== null &&
            Array.isArray(res.data.result)
          ) {
            this.labs = res.data.result;
          }
        });
      //   await this.$axios
      //     .get(`/api/u/auth/options`,{
      //             validateStatus: function(status) {
      //               return status >= 200 && status < 404; // default
      //             }
      //           })
      //     .then(res => {
      //       console.log("remoteUsers init: ",res);
      //       if (
      //         res.status === 200 &&
      //         res.data &&
      //         res.data.result &&
      //         res.data.result !== null &&
      //         Array.isArray(res.data.result)
      //       ) {
      //         this.users = res.data.result;
      //       }
      //     });
    },
    async remoteLabs(query) {
      await this.$axios
        .get(
          `/api/u/dental/factory/options?pageSize=40000&factoryType=lab&name=${query}`,
          {
            validateStatus: function(status) {
              return status >= 200 && status < 404; // default
            }
          }
        )
        .then(res => {
          console.log(res);
          if (
            res.status === 200 &&
            res.data &&
            res.data.result &&
            res.data.result !== null &&
            Array.isArray(res.data.result)
          ) {
            this.labs = res.data.result;
          }
        });
    },
    async remoteMembers(query) {
      await this.$axios
        .get(`/api/u/dental/member/options?pageSize=40000&name=${query}`, {
          validateStatus: function(status) {
            return status >= 200 && status < 404; // default
          }
        })
        .then(res => {
          console.log(res);
          if (
            res.status === 200 &&
            res.data &&
            res.data.result &&
            res.data.result !== null &&
            Array.isArray(res.data.result)
          ) {
            this.members = res.data.result;
          }
        });
    },
    // async remoteUsers(query) {
    //   await this.$axios
    //     .get(`/api/u/auth/options?pageSize=40000&name=${query}`,{
    //             validateStatus: function(status) {
    //               return status >= 200 && status < 404; // default
    //             }
    //           })
    //     .then(res => {
    //       console.log("remoteUsers: ",res);
    //       if (
    //         res.status === 200 &&
    //         res.data &&
    //         res.data.result &&
    //         res.data.result !== null &&
    //         Array.isArray(res.data.result)
    //       ) {
    //         this.users = res.data.result;
    //       }
    //     });
    // },
    toggleSearchForm() {
      var el = document.querySelector(".search_form");
      var elBtn = document.querySelector(".search_expand_area .el-icon--right");
      // console.log();
      if (el.style.display === "" || el.style.display === "none") {
        el.style.display = "block";
        elBtn.classList.remove("el-icon-arrow-right");
        elBtn.classList.add("el-icon-arrow-down");
      } else {
        el.style.display = "none";
        elBtn.classList.remove("el-icon-arrow-down");
        elBtn.classList.add("el-icon-arrow-right");
      }
    },
    onSearchReset() {
      console.log(this.$route.query);
      this.searchForm = {
        labName: "",
        userName: "",
        status: ""
      };
    },
    initSearch() {
      var queryObj = this.$route.query;
      if (queryObj["labName"]) {
        this.searchForm.labName = queryObj["labName"];
      }
      if (queryObj["userName"]) {
        this.searchForm.userName = queryObj["userName"];
      }
      if (queryObj["status"]) {
        this.searchForm.status = queryObj["status"];
      }
    },
    searchSubmit() {
      console.log(this.searchForm);
      var queryObj = this.$route.query;
      queryObj["labName"] = this.searchForm.labName;
      queryObj["userName"] = this.searchForm.userName;
      queryObj["status"] = this.searchForm.status;
      queryObj["page"] = 1;
      console.log(queryObj);
      Object.keys(queryObj).map((k, i) => {
        if (
          queryObj[k] === undefined ||
          queryObj[k] === "" ||
          (k === "page" && queryObj[k] === 1)
        ) {
          delete queryObj[k];
        }
      });
      console.log(queryObj);
      window.location = this.$router.resolve({
        name: "connections",
        query: queryObj
      }).href;
    },
    handleSizeChange(val) {
      console.log(val);
      var queryObj = this.$route.query;
      queryObj["pageSize"] = val;
      queryObj["page"] = 1;
      window.location = this.$router.resolve({
        name: "connections",
        query: queryObj
      }).href;
      // this.$redirect({name:'cases',query: queryObj});
    },
    handleCurrentChange(val) {
      console.log(val);
      var queryObj = this.$route.query;
      queryObj["page"] = val;
      window.location = this.$router.resolve({
        name: "connections",
        query: queryObj
      }).href;
      // this.$redirect({name:'cases',query: queryObj});
    }
  },
  mounted() {
    // console.log("this.perms: ", this.$store.state.perms);
    // console.log("this.$perms: ", this.$perms);
    this.initSearch();
    // this.setPerm();
    console.log("this.perms: ", this.perms);
    console.log("mounted:",pub.cdnUrl);
  },
  metaInfo() {
    return {
      title: this.$gf.sysParam(this.$gf.lang(), 'title') + "-" + this.$t("cmsg.connections")
    };
  },
  async asyncData(context) {
    let pageInfo = { page: 0, pageSize: 50, pages: 0, total: 0 };
    let items = [];
    let perms = [];
    var activeIndex = "all";
    if (context.req && context.req.query && context.req.query.status) {
      activeIndex = context.req.query.status;
    }
    await context.$axios
      .get("/api/u/dental/connection/list", {
        json: true,
        params: context.route.query,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res)
        // var items = [];
        if (res.data.result && Array.isArray(res.data.result)) {
          items = res.data.result.map(item => {
            if (item.ChangeBy.Valid) {
              item.ChangeBy = JSON.parse(item.ChangeBy.String);
            } else {
              item.ChangeBy = {};
            }
            if (item.CreateBy.Valid) {
              item.CreateBy = JSON.parse(item.CreateBy.String);
            } else {
              item.CreateBy = {};
            }
            if (item.TargetUser.Valid) {
              item.TargetUser = JSON.parse(item.TargetUser.String);
            } else {
              item.TargetUser = {};
            }
            if (item.TargetLab.Valid) {
              item.TargetLab = JSON.parse(item.TargetLab.String);
            } else {
              item.TargetLab = {};
            }
            if (item.TargetLabAdmins.Valid) {
              item.TargetLabAdmins = JSON.parse(item.TargetLabAdmins.String);
              item.TLAs = [];
              item.TargetLabAdmins.forEach(tla => {
                item.TLAs.push(tla.UserID);
              });
            } else {
              item.TargetLabAdmins = {};
              item.TLAs = [];
            }
            if (item.User.Valid) {
              item.User = JSON.parse(item.User.String);
            } else {
              item.User = {};
            }
            return item;
          });
          pageInfo = res.data.pageInfo;
        }
      })
      .catch(e => {
        console.log(e);
      });
    await context.$axios
      .get(`/api/u/settings/b/up`, {
        json: true,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        if (
          res.status === 200 &&
          res.data &&
          res.data.status === "success" &&
          res.data.result !== null
        ) {
          // console.log(res);
          perms = res.data.result;
        }
      })
      .catch(e => {
        console.log(e);
      });
    // console.log(items);
    return {
      pageInfo: pageInfo,
      items: items,
      perms: perms,
      tableLoading: false,
      activeIndex: activeIndex
    };
  }
};
</script>
<style lang="scss">
.fileDownPopover {
  .el-button {
    display: block;
    margin-left: 0px;
  }
}
#connections {
  .main {
    background-color: #f7f9fb;
    padding: 15px;
    text-align: left;
    .case_nav {
      display: flex;
      overflow: auto;
    }
    .el-menu-item {
      display: inline;
      border-top: 1px solid #e6e6e6;
      border-left: 1px solid #e6e6e6;
    }
    .el-menu-item.is-active {
      background-color: #f3f3f3;
    }
    .el-menu-item:last-of-type {
      border-right: 1px solid #e6e6e6;
    }
    .hidden_delivery {
      display: none;
    }
    .large_preview {
      width: 80%;
    }
    .large_preview .el-message-box__content {
      overflow: auto;
    }
    .el-table__expanded-cell[class*="cell"] {
      padding: 0px 0px 15px 0px;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      border-top-width: 0px;
    }
    .case_btn {
      margin-right: 5px;
      margin-bottom: 5px;
      margin-left: 0px !important;
    }
    .search_expand_area {
      display: none;
    }
    .search_form {
      display: block;
    }
    @media screen and (min-width: 1020px) {
      .search_expand_area {
        display: none;
      }
      .search_form {
        display: block;
      }
    }
    .el-table__expanded-cell[class*="cell"] {
      padding-bottom: 0px !important;
    }
    @media screen and (max-width: 1020px) {
      .search_expand_area {
        display: block;
      }
      .search_form {
        display: none;
      }
      .el-menu-item [class^="el-icon-"] {
        margin-right: 0px;
      }
      .el-menu-item:not(.is-active) .dp_title {
        display: none;
        /* display: inline; */
      }
      .is-active .dp_title {
        display: inline;
      }
      .el-menu-item {
        padding: 0 0px 0 5px;
      }
      .el-pager li:not(.active) {
        display: none;
      }
    }
  }
}
</style>
